import { MerchantService, RetailPayout } from '@galaxy/billing';
import { PagedListRequestInterface, PagedResponseInterface, PaginatedAPIInterface } from '@vendasta/galaxy/table';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';

export class PayoutListDataSource implements PaginatedAPIInterface<RetailPayout> {
  private _loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _loading$ = this._loading$$.asObservable();

  constructor(
    private merchantService: MerchantService,
    private merchantId$: Observable<string>,
  ) {}

  get(r: PagedListRequestInterface): Observable<PagedResponseInterface<RetailPayout>> {
    return this.merchantId$.pipe(
      tap((_) => this._loading$$.next(true)),
      switchMap((merchantId) => {
        return this.merchantService.listRetailPayouts(
          merchantId,
          r.pagingOptions!.cursor ?? '',
          r.pagingOptions!.pageSize ?? 50,
        );
      }),
      map((response) => {
        this._loading$$.next(false);
        return {
          data: response.results,
          pagingMetadata: {
            nextCursor: response.nextCursor,
            hasMore: response.hasMore,
          },
        };
      }),
    );
  }

  public loading$(): Observable<boolean> {
    return this._loading$;
  }
}
